import * as THREE from 'three'

export const hollowgramShader = {
  vertexShader: /* glsl */`// hologram.vert
    varying vec3 vWorldPos;
    varying vec3 vNormal;

    void main() {
        vec4 worldPos = modelMatrix * vec4(position, 1.0);
        vWorldPos = worldPos.xyz;
        vNormal = normalize(mat3(modelMatrix) * normal);

        gl_Position = projectionMatrix * viewMatrix * worldPos;
    }
  `,
  vertexShaderNew: /* glsl */`// hologram.vert
    // fishSwim.vert
    uniform float time;
    uniform float swimSpeed;
    uniform float swimStrength;
    uniform float bodyLength;
    uniform float scale;

    // steering
    uniform float turn;          // -1 (left) .. +1 (right)
    uniform float turnStrength;  // e.g. 0.3

    varying vec2 vUv;
    varying vec3 vNormal;
    varying vec3 vWorldPos;

    void main() {

        vUv = uv;

        vec3 pos = position;
        pos *= scale; // scale if needed

        // body parameter: 0 = head, 1 = tail
        float t = 1.0 - clamp((pos.x + bodyLength * 0.5) / bodyLength, 0.0, 1.0);

        // ============================
        // 1) TRAVELING SWIM WAVE
        // ============================
        float phase = time * swimSpeed - t * 6.28318;
        float wave  = sin(phase);

        float amp = swimStrength * t * t;

        float swimOffset = wave * amp;

            // 🟡 STEP 2: secondary tail ripple (very subtle)
        pos.z += sin(time * swimSpeed * 1.7 - t * 12.0) * amp * 0.2;

        // ============================
        // 2) STEERING BIAS (HEAD LEADS)
        // ============================
        // strongest at head, weaker at tail
        float steerFalloff = smoothstep(1.0, 0.0, t);

        float steerOffset = turn * turnStrength * steerFalloff;

        // ============================
        // 3) COMBINE MOTION
        // ============================
        pos.z += swimOffset + steerOffset;

        // counter-bend to stabilize body mass
        pos.z -= sin(time * swimSpeed) * amp * 0.15;

        // subtle vertical buoyancy (very small)
        pos.y += sin(time * swimSpeed * 0.6 + t * 3.0) * .05 * t;

        // 🟢 HEAD LOOK (subtle, independent motion)
        float headWeight = smoothstep(0.0, 0.35, t); // head only
        float look = sin(time * 0.8) * .1;         // very small
        pos.z += look * headWeight;

        // 🟣 whole-fish vertical drift (new)
        pos.y += sin(time * 0.7) * 0.08;

        // ============================
        // ⭐ APPLY INSTANCE TRANSFORM
        // ============================
        vec4 localPos = vec4(pos, 1.0);
        #ifdef USE_INSTANCING
            localPos = instanceMatrix * localPos;
        #endif
        vec4 worldPos = modelMatrix * localPos;

        vWorldPos = worldPos.xyz;
        #ifdef USE_INSTANCING
            mat3 nMat = mat3(modelMatrix * instanceMatrix);
        #else
            mat3 nMat = mat3(modelMatrix);
        #endif

        vNormal = normalize(nMat * normal);

        gl_Position = projectionMatrix * viewMatrix * worldPos ;
    }

  `,
  vertexShaderOld: /* glsl */`
    // fishSwim.vert
    uniform float time;
    uniform float swimSpeed;
    uniform float swimStrength;
    uniform float bodyLength;

    varying vec2 vUv;
    varying vec3 vNormal;
    varying vec3 vWorldPos;

    void main() {

        vUv = uv;

        vec3 pos = position;
        pos *= 

        // body parameter: 0 = head, 1 = tail
        float t = 1. - clamp((pos.x + bodyLength * 0.5) / bodyLength, 0.0, 1.0);

        // ----------------------------
        // Traveling wave (head -> tail)
        // ----------------------------
        float phase = time * swimSpeed - t * 6.28318;
        float wave  = sin(phase);

        // amplitude increases toward tail
        float amp = swimStrength * t * t; // squared = stronger tail dominance

        pos.z += wave * amp;

        // ----------------------------
        // Mild counter-bend near head
        // (prevents whole body drifting)
        // ----------------------------
        pos.z -= sin(time * swimSpeed) * amp * 0.15;

        // world outputs
        vec4 worldPos = modelMatrix * vec4(pos, 1.0);
        vWorldPos = worldPos.xyz;
        vNormal = normalize(normalMatrix * normal);

        gl_Position = projectionMatrix * viewMatrix * worldPos;
    }

  `,
  fragTest: /* glsl */`// test.frag
  // fish.frag
varying vec3 vNormal;

void main() {
    vec3 lightDir = normalize(vec3(0.3, 1.0, 0.5));
    float diff = max(dot(normalize(vNormal), lightDir), 0.0);
    vec3 color = vec3(0.2, 0.6, 0.8) * diff + 0.1;
    gl_FragColor = vec4(color, 1.0);
}
  `,
  fragTestFish: /* glsl */`// test.frag
 // hologram.frag
    uniform sampler2D map;
    uniform float time;
    uniform vec3 color;      // hologram glow color
    uniform float opacity;   // texture transparency (0.3–0.7)

    varying vec2 vUv;
    varying vec3 vWorldPos;
    varying vec3 vNormal;

    float rand(vec2 co){
        return fract(sin(dot(co, vec2(12.9898,78.233))) * 43758.5453);
    }

    void main() {

        // ----------------------------
        // Sample texture (BASE LAYER)
        // ----------------------------
        vec3 texColor = texture2D(map, vUv).rgb;

        // ----------------------------
        // View direction
        // ----------------------------
        vec3 viewDir = normalize(cameraPosition - vWorldPos);

        // ----------------------------
        // Fresnel (EDGE MASK)
        // ----------------------------
        float fresnel = 1.0 - dot(viewDir, normalize(vNormal));
        fresnel = pow(fresnel, 2.5);

        // ----------------------------
        // Pixelated noise (stable)
        // ----------------------------
        float noisePixelSize = 0.25;
        vec2 noiseUV = floor(vWorldPos.xz / noisePixelSize) * noisePixelSize;
        float noise = rand(noiseUV + floor(time * 4.0));
        noise = mix(0.85, 1.0, noise);

        // ----------------------------
        // ALWAYS-ON HOLOGRAM GLOW
        // ----------------------------

        // subtle base glow everywhere
        float baseGlow = 0.9;

        // edge boost (adds on top, not gates)
        float edgeGlow = fresnel * 0.25;

        // combine glow terms
        float glow = (baseGlow) * noise;

        // final glow color
        vec3 glowColor = color * glow * 0.25;

        // ----------------------------
        // FINAL COMPOSITION
        // ----------------------------
        vec3 finalColor = texColor * opacity + glowColor;

        gl_FragColor = vec4(finalColor, opacity);
    }
  `,
  fragTestFishOld: /* glsl */`// test.frag
    // fishHologram.frag
    uniform sampler2D map;       // fish texture
    uniform float time;
    uniform vec3 holoColor;      // hologram tint
    uniform float holoStrength;  // 0.0–1.0

    varying vec2 vUv;
    varying vec3 vWorldPos;
    varying vec3 vNormal;

    float luma(vec3 c) {
        return dot(c, vec3(0.299, 0.587, 0.114));
    }

    void main() {

        // ----------------------------
        // Base texture (KEEP DETAIL)
        // ----------------------------
        vec3 texColor = texture2D(map, vUv).rgb;

        // ----------------------------
        // Fresnel for edges
        // ----------------------------
        vec3 viewDir = normalize(cameraPosition - vWorldPos);
        float fresnel = pow(1.0 - dot(viewDir, normalize(vNormal)), 2.5);

        // ----------------------------
        // Scanline effect
        // ----------------------------
        float scan = sin(vWorldPos.y * 10.0 - time * 6.0);
        scan = smoothstep(0.2, 0.8, scan);

        // ----------------------------
        // Hologram intensity
        // ----------------------------
        float holo = fresnel * 0.6 + scan * 0.4;

        // ----------------------------
        // Combine (NON-DESTRUCTIVE)
        // ----------------------------
        vec3 color = texColor;
        color += holoColor * holo * holoStrength;

        gl_FragColor = vec4(color, 1.0);
    }

  `,
  fragmentShader: /* glsl */`// hologram.frag
      // hologram.frag
    uniform float time;
    uniform vec3 color;
    uniform float opacity;

    varying vec3 vWorldPos;
    varying vec3 vNormal;

    float rand(vec2 co){
        return fract(sin(dot(co, vec2(12.9898,78.233))) * 43758.5453);
    }

    void main() {

        // ----------------------------
        // View direction
        // ----------------------------
        vec3 viewDir = normalize(cameraPosition - vWorldPos);

        // ----------------------------
        // Fresnel (edge glow)
        // ----------------------------
        float fresnel = pow(1.0 - dot(viewDir, normalize(vNormal)), 2.5);

        // ----------------------------
        // Scan lines (horizontal)
        // ----------------------------
        float scan = sin((vWorldPos.y * 10.0) - time * 6.0);
        scan = smoothstep(-0.2, 0.2, scan);

        // ----------------------------
        // Noise flicker
        // ----------------------------
        float noise = rand(vWorldPos.xz + time * 0.1);
        noise = smoothstep(0.4, 1.0, noise);

        // ----------------------------
        // Final intensity
        // ----------------------------
        float intensity = fresnel * 1.8;
        intensity += scan * 0.25;
        intensity *= noise;

        // ----------------------------
        // Color & alpha
        // ----------------------------
        vec3 holoColor = color * intensity;
        float alpha = intensity * opacity;

        // discard very transparent fragments (clean hollow look)
        if (alpha < 0.02) discard;

        gl_FragColor = vec4(holoColor, alpha);
    }
  `,
  fragmentShaderNew: /* glsl */`// hologram.frag
      // tron.frag
    uniform float time;
    uniform vec3 tronColor;     // main glow color
    uniform float opacity;

    varying vec3 vWorldPos;
    varying vec3 vNormal;

    void main() {

        // view direction
        vec3 viewDir = normalize(cameraPosition - vWorldPos);

        // ----------------------------
        // Fresnel edge glow (cheap)
        // ----------------------------
        float fresnel = 1.0 - dot(viewDir, normalize(vNormal));
        fresnel = pow(fresnel, 3.0);

        // ----------------------------
        // Horizontal animated lines
        // ----------------------------
        float line = sin(vWorldPos.y * 12.0 - time * 8.0);
        line = smoothstep(0.4, 0.6, line);

        // ----------------------------
        // Combine intensity
        // ----------------------------
        float intensity = fresnel * 0.8 + line * 0.3;

        // ----------------------------
        // Color & alpha
        // ----------------------------
        vec3 color = tronColor * intensity;
        float alpha = intensity * opacity;

        // Hollow look
        if (alpha < 0.05) discard;

        gl_FragColor = vec4(color, alpha);
    }

  `,
  fragmentShaderNew2: /* glsl */`// tron.frag
      // tronBike.frag
    uniform float time;
    uniform vec3 baseColor;   // dark body color
    uniform vec3 glowColor;   // neon lines
    uniform float glowStrength;

    varying vec3 vWorldPos;
    varying vec3 vNormal;

    void main() {

        // view direction
        vec3 viewDir = normalize(cameraPosition - vWorldPos);

        // ----------------------------
        // Fresnel edge glow (subtle)
        // ----------------------------
        float fresnel = 1.0 - dot(viewDir, normalize(vNormal));
        fresnel = pow(fresnel, 2.5);

        // ----------------------------
        // TRON light strips (animated)
        // ----------------------------
        // // use world Y (or X/Z) to create bands
        // float bands = sin(vWorldPos.y * 10.0 - time * 6.0);
        // bands = smoothstep(0.7, 1.0, bands);

        // ------------------------------------
        // EDGE-ALIGNED FLOWING LINES (TRON)
        // ------------------------------------

        // Fresnel already computed earlier
        // fresnel = pow(1.0 - dot(viewDir, normal), X);

        // Project normal into a stable 2D space
        vec2 flowUV = normalize(vNormal.xy + 0.0001);

        // Flowing wave along the surface orientation
        float flow = sin((flowUV.x + flowUV.y) * 12.0 - time * 8.0);

        // Sharpen into thin glowing lines
        flow = smoothstep(0.85, 1.0, flow);

        // Only appear near edges
        float edgeFlow = flow * fresnel;


        // ----------------------------
        // Combine glow
        // ----------------------------
        // float glow = bands + fresnel * 0.6;
        float glow = fresnel * 0.6 + edgeFlow;

        glow = clamp(glow, 0.0, 1.0);

        // ----------------------------
        // Final color
        // ----------------------------
        vec3 color = baseColor;                    // solid body
        color += glowColor * glow * glowStrength;  // emissive glow

        gl_FragColor = vec4(color, 1.0); // solid, no transparency
    }
    `
  
};

export const crtPosterShaderMoving = {
  vertexShader: /* glsl */`
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: /* glsl */`
    uniform sampler2D mapA;
    uniform sampler2D mapB;
    uniform float time;
    uniform vec2 resolution;   // renderer size in pixels
    uniform float stripeWidth; // column width in pixels (2.0–6.0)
    uniform float dotHeight;   // dot height in pixels (2.0–6.0)
    uniform vec3 glowColor;    // e.g. vec3(0.4, 1.0, 0.7)
    uniform float uvRotation;
    uniform float uBloomIntensity;

    varying vec2 vUv;

    float luma(vec3 c) {
      return dot(c, vec3(0.299, 0.587, 0.114));
    }

    // random helper (time-driven)
    float rand(float x){
      return fract(sin(x)*43758.5453123);
    }

    vec2 rotateUV(vec2 uv, float angle) {
        // translate uv to center
        uv -= 0.5;

        float c = cos(angle);
        float s = sin(angle);

        // 2D rotation matrix
        mat2 r = mat2(c, -s,
                    s,  c);

        uv = r * uv;

        // translate back
        uv += 0.5;
        return uv;
    }

    void main() {
      vec2 uv = rotateUV(vUv, uvRotation);
      uv.y = 1.0 - uv.y;
      vec2 frag = gl_FragCoord.xy;  // screen-space in pixels

      float switchTime = 3.;

      // which image?
      float idx = mod(floor(time / switchTime), 2.0);
      float t = sin(time * 3.14159 * .8) - 0.; // 10 Hz = 50ms period

    
      // sample both (avoid branching)
      vec3 srcA = texture2D(mapA, uv).rgb;
      vec3 srcB = texture2D(mapB, uv).rgb;
      // blend based on idx
    //   float useB = step(1.0, idx); // if idx>=1 → 1, else 0
        float useB = smoothstep(0.0, 1.0, t*0.5+0.5);

      vec3 src = mix(srcA, srcB, useB);

      // sample image brightness
    //   vec3 src = texture2D(map, uv).rgb;
      float b = luma(src);                    // 0..1 brightness

      // --- transparency based on brightness
      // gamma boost to push mid-tones brighter, dark fade out
      float alpha = pow(b, 1.4);              // dark → transparent

      // a base subtle flicker
      float flicker = 1.0 + 0.03 * sin(time * 60.0);

      // occasional heavy flicker events:
      float flickerGate = step(0.96, rand(floor(time * 2.0))); 
      float flickerBig  = 1.0 + flickerGate * (0.25 * sin(time * 80.0 + rand(time)));

      float flickerFinal = flicker * flickerBig;

      // --- screen-space columns
      float stripePx = max(stripeWidth, 1.0);
      float cx = fract(frag.x / stripePx) - 0.5;
      float colShape = 1.0 - smoothstep(0.45, 0.5, abs(cx));

      // --- screen-space rows (dots)
      float dotPx = max(dotHeight, 1.0);
      float cy = fract(frag.y / dotPx) - 0.5;
      float rowShape = 1.0 - smoothstep(0.3, 0.5, abs(cy));

      float shapeMask = colShape * rowShape;

      // --- scan jitter
      float scan = 0.9 + 0.1 * sin(frag.y * 0.25 + time * 8.0);
      shapeMask *= scan;

      // --- slight vignette
      vec2 centered = uv - 0.5;
      float r = length(centered);
      float vignette = 1.0 - smoothstep(0.45, 0.85, r);
      float mask = shapeMask * vignette;

      // final glow based on brightness
      vec3 color = glowColor * b * mask * flickerFinal * 1.2;

      // slight bloom curve
      color = color * (1.0 + color * uBloomIntensity);
      color = pow(color, vec3(0.9));

      // alpha: combine brightness + mask for nice fade
      float finalAlpha = alpha * mask;

      gl_FragColor = vec4(color, finalAlpha);
    }
  `,
  fragmentShaderNew: /* glsl */`
  uniform sampler2D mapA;
  uniform sampler2D mapB;
  uniform float time;
  uniform vec2 resolution;   // renderer size in pixels
  uniform float stripeWidth; // column width in pixels (2.0–6.0)
  uniform float dotHeight;   // dot height in pixels (2.0–6.0)
  uniform vec3 glowColor;    // legacy / fallback (still available)
  uniform float uvRotation;
  uniform float uBloomIntensity;

  // new tint uniforms
  uniform vec3 tintColor;
  uniform float tintMix; // 0..1

  varying vec2 vUv;

  float luma(vec3 c) {
    return dot(c, vec3(0.299, 0.587, 0.114));
  }

  // random helper (time-driven)
  float rand(float x){
    return fract(sin(x)*43758.5453123);
  }

  vec2 rotateUV(vec2 uv, float angle) {
      // translate uv to center
      uv -= 0.5;
      float c = cos(angle);
      float s = sin(angle);
      // 2D rotation matrix
      mat2 r = mat2(c, -s,
                    s,  c);
      uv = r * uv;
      // translate back
      uv += 0.5;
      return uv;
  }

  void main() {
    // rotated UV + flip-y (keeps your existing behavior)
    vec2 uv = rotateUV(vUv, uvRotation);
    uv.y = 1.0 - uv.y;
    vec2 frag = gl_FragCoord.xy;  // screen-space in pixels

    float switchTime = 3.0;

    // switching / crossfade (you can replace with glitch logic)
    float idx = mod(floor(time / switchTime), 2.0);
    float t = sin(time * 3.14159 * 0.8) - 0.0; // soft cross timing
    float useB = smoothstep(0.0, 1.0, t * 0.5 + 0.5);

    // sample both image textures
    vec3 srcA = texture2D(mapA, uv).rgb;
    vec3 srcB = texture2D(mapB, uv).rgb;
    vec3 src = mix(srcA, srcB, useB);

    // brightness (used for alpha + tint weighting)
    float b = luma(src);                    // 0..1 brightness

    // transparency based on brightness (dark -> transparent)
    float alpha = pow(b, 1.4);

    // flicker (unchanged)
    float flicker = 1.0 + 0.03 * sin(time * 60.0);
    float flickerGate = step(0.96, rand(floor(time * 2.0)));
    float flickerBig  = 1.0 + flickerGate * (0.25 * sin(time * 80.0 + rand(time)));
    float flickerFinal = flicker * flickerBig;

    // --- screen-space columns
    float stripePx = max(stripeWidth, 1.0);
    float cx = fract(frag.x / stripePx) - 0.5;
    float colShape = 1.0 - smoothstep(0.45, 0.5, abs(cx));

    // --- screen-space rows (dots)
    float dotPx = max(dotHeight, 1.0);
    float cy = fract(frag.y / dotPx) - 0.5;
    float rowShape = 1.0 - smoothstep(0.3, 0.5, abs(cy));

    float shapeMask = colShape * rowShape;

    // --- scan jitter (unchanged)
    float scan = 0.9 + 0.1 * sin(frag.y * 0.25 + time * 8.0);
    shapeMask *= scan;

    // --- slight vignette
    vec2 centered = uv - 0.5;
    float r = length(centered);
    float vignette = 1.0 - smoothstep(0.45, 0.85, r);
    float mask = shapeMask * vignette;

    // ----------------------------
    // Color + Tint blending logic
    // ----------------------------
    // base image color modulated by mask & flicker
    vec3 baseColor = src * (b * mask * flickerFinal);

    // tint contribution: tint * brightness * mask * flicker
    vec3 tintContribution = tintColor * (b * mask * flickerFinal);

    // mix original sampled color with tint hint (tintMix controls strength)
    // note: tintMix = 0 => original color only; tintMix = 1 => full tintColor
    vec3 mixed = mix(baseColor, tintContribution, clamp(tintMix, 0.0, 1.0));

    // slight bloom curve applied to the mixed result
    vec3 color = mixed * (1.0 + mixed * uBloomIntensity);
    color = pow(color, vec3(0.9));

    // alpha: combine brightness + mask
    float finalAlpha = alpha * mask;

    // optional: discard fully transparent fragments for perfect cutout
    // if (finalAlpha < 0.01) discard;

    gl_FragColor = vec4(color, finalAlpha);
  }
`

};

export const crtPosterShaderStable = {
  vertexShader: /* glsl */`
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: /* glsl */`
    uniform sampler2D map;     // poster image (can be null, we force a minimum brightness)
    uniform float time;
    uniform vec2 resolution;   // renderer size in pixels
    uniform float stripeWidth; // column width in pixels (2.0–6.0)
    uniform float dotHeight;   // dot height in pixels (2.0–6.0)
    uniform vec3 glowColor;    // e.g. vec3(0.4, 1.0, 0.7)
    uniform float uvRotation;
    uniform float uBloomIntensity;
    
    varying vec2 vUv;

    float luma(vec3 c) {
      return dot(c, vec3(0.299, 0.587, 0.114));
    }

    // random helper (time-driven)
    float rand(float x){
      return fract(sin(x)*43758.5453123);
    }

    vec2 rotateUV(vec2 uv, float angle) {
      // translate uv to center
      uv -= 0.5;

      float c = cos(angle);
      float s = sin(angle);

      // 2D rotation matrix
      mat2 r = mat2(c, -s,
                  s,  c);

      uv = r * uv;

      // translate back
      uv += 0.5;
      return uv;
    }

    void main() {
      vec2 uv = rotateUV(vUv, uvRotation);
      uv.y = 1.0 - uv.y;
      vec2 frag = gl_FragCoord.xy;  // screen-space in pixels

      // sample image brightness
      vec3 src = texture2D(map, uv).rgb;
      float b = luma(src);                    // 0..1 brightness

      // --- transparency based on brightness
      // gamma boost to push mid-tones brighter, dark fade out
      float alpha = pow(b, 1.4);              // dark → transparent

      // a base subtle flicker
      float flicker = 1.0 + 0.03 * sin(time * 60.0);

      // occasional heavy flicker events:
      float flickerGate = step(0.96, rand(floor(time * 2.0))); 
      float flickerBig  = 1.0 + flickerGate * (0.25 * sin(time * 80.0 + rand(time)));

      float flickerFinal = flicker * flickerBig;

      // --- screen-space columns
      float stripePx = max(stripeWidth, 1.0);
      float cx = fract(frag.x / stripePx) - 0.5;
      float colShape = 1.0 - smoothstep(0.45, 0.5, abs(cx));

      // --- screen-space rows (dots)
      float dotPx = max(dotHeight, 1.0);
      float cy = fract(frag.y / dotPx) - 0.5;
      float rowShape = 1.0 - smoothstep(0.3, 0.5, abs(cy));

      float shapeMask = colShape * rowShape;

      // --- scan jitter
      float scan = 0.9 + 0.1 * sin(frag.y * 0.25 + time * 8.0);
      shapeMask *= scan;

      // --- slight vignette
      vec2 centered = uv - 0.5;
      float r = length(centered);
      float vignette = 1.0 - smoothstep(0.45, 0.85, r);
      float mask = shapeMask * vignette;

      // final glow based on brightness
      vec3 color = glowColor * b * mask * flickerFinal * 1.2;

      // slight bloom curve
      color = color * (1.0 + color * 1.2);
      color = pow(color, vec3(0.9));

      // alpha: combine brightness + mask for nice fade
      float finalAlpha = alpha * mask;

      gl_FragColor = vec4(color, finalAlpha);
    }
  `,
  fragmentShaderNew: /* glsl */`
  uniform sampler2D map;     // poster image
  uniform float time;
  uniform vec2 resolution;   // renderer size in pixels
  uniform float stripeWidth; // column width in pixels (2.0–6.0)
  uniform float dotHeight;   // dot height in pixels (2.0–6.0)
  uniform vec3 glowColor;    // legacy / fallback (kept)
  uniform float uvRotation;
  uniform float uBloomIntensity;

  // new tint uniforms
  uniform vec3 tintColor;
  uniform float tintMix; // 0..1

  varying vec2 vUv;

  float luma(vec3 c) {
    return dot(c, vec3(0.299, 0.587, 0.114));
  }

  // random helper (time-driven)
  float rand(float x){
    return fract(sin(x)*43758.5453123);
  }

  vec2 rotateUV(vec2 uv, float angle) {
    // translate uv to center
    uv -= 0.5;
    float c = cos(angle);
    float s = sin(angle);
    // 2D rotation matrix
    mat2 r = mat2(c, -s,
                  s,  c);
    uv = r * uv;
    // translate back
    uv += 0.5;
    return uv;
  }

  void main() {
    vec2 uv = rotateUV(vUv, uvRotation);
    uv.y = 1.0 - uv.y;
    vec2 frag = gl_FragCoord.xy;  // screen-space in pixels

    // --- sample the image color and compute brightness ---
    vec3 src = texture2D(map, uv).rgb;
    float b = luma(src); // brightness 0..1

    // --- transparency based on brightness (dark -> transparent) ---
    float alpha = pow(b, 1.4);

    // --- flicker ---
    float flicker = 1.0 + 0.03 * sin(time * 60.0);
    float flickerGate = step(0.96, rand(floor(time * 2.0)));
    float flickerBig  = 1.0 + flickerGate * (0.25 * sin(time * 80.0 + rand(time)));
    float flickerFinal = flicker * flickerBig;

    // --- screen-space columns
    float stripePx = max(stripeWidth, 1.0);
    float cx = fract(frag.x / stripePx) - 0.5;
    float colShape = 1.0 - smoothstep(0.45, 0.5, abs(cx));

    // --- screen-space rows (dots)
    float dotPx = max(dotHeight, 1.0);
    float cy = fract(frag.y / dotPx) - 0.5;
    float rowShape = 1.0 - smoothstep(0.3, 0.5, abs(cy));

    float shapeMask = colShape * rowShape;

    // --- scan jitter
    float scan = 0.9 + 0.1 * sin(frag.y * 0.25 + time * 8.0);
    shapeMask *= scan;

    // --- vignette
    vec2 centered = uv - 0.5;
    float r = length(centered);
    float vignette = 1.0 - smoothstep(0.45, 0.85, r);
    float mask = shapeMask * vignette;

    // ----------------------------
    // Color + Tint blending logic
    // ----------------------------
    // base sampled color modulated by mask and flicker (preserve hues)
    vec3 baseColor = src * (mask * flickerFinal);

    // tint contribution: apply tint scaled by brightness so it affects highlights more
    vec3 tintContribution = tintColor * (b * mask * flickerFinal);

    // mix sampled color and tint; clamp tintMix
    vec3 mixed = mix(baseColor, tintContribution, clamp(tintMix, 0.0, 1.0));

    // small heritage glow option: mix a touch of glowColor (kept for compatibility)
    mixed = mix(mixed, glowColor * (b * mask * flickerFinal), 0.0); // 0.0 => disable; change if desired

    // apply bloom curve and gamma
    vec3 color = mixed * (1.0 + mixed * uBloomIntensity);
    color = pow(color, vec3(0.9));

    // final alpha combines brightness + mask
    float finalAlpha = alpha * mask;

    // optionally discard near-zero alpha for fully cutout behavior (uncomment if wanted)
    // if (finalAlpha < 0.01) discard;

    gl_FragColor = vec4(color, finalAlpha);
  }
`,
  fragmentShaderNew2: /* glsl */`
  uniform sampler2D map;     // poster image
  uniform float time;
  uniform vec2 resolution;   // renderer size in pixels
  uniform float stripeWidth; // column width in pixels (2.0–6.0)
  uniform float dotHeight;   // dot height in pixels (2.0–6.0)
  uniform vec3 glowColor;    // legacy / fallback (kept)
  uniform float uvRotation;
  uniform float uBloomIntensity;

  // new tint uniforms
  uniform vec3 tintColor;
  uniform float tintMix; // 0..1

  varying vec2 vUv;

  float luma(vec3 c) {
    return dot(c, vec3(0.299, 0.587, 0.114));
  }

  // random helper (time-driven)
  float rand(float x){
    return fract(sin(x)*43758.5453123);
  }

  vec2 rotateUV(vec2 uv, float angle) {
    // translate uv to center
    uv -= 0.5;
    float c = cos(angle);
    float s = sin(angle);
    // 2D rotation matrix
    mat2 r = mat2(c, -s,
                  s,  c);
    uv = r * uv;
    // translate back
    uv += 0.5;
    return uv;
  }

  void main() {
    vec2 uv = rotateUV(vUv, uvRotation);
    uv.y = 1.0 - uv.y;
    vec2 frag = gl_FragCoord.xy;  // screen-space in pixels

    // --- sample the image color and compute brightness ---
    vec3 src = texture2D(map, uv).rgb;
    float b = luma(src); // brightness 0..1

    // --- transparency based on brightness (dark -> transparent) ---
    float alpha = pow(b, 1.4);

    // --- flicker ---
    float flicker = 1.0 + 0.03 * sin(time * 60.0);
    float flickerGate = step(0.96, rand(floor(time * 2.0)));
    float flickerBig  = 1.0 + flickerGate * (0.25 * sin(time * 80.0 + rand(time)));
    float flickerFinal = flicker * flickerBig;

    // --- screen-space columns
    float stripePx = max(stripeWidth, 1.0);
    float cx = fract(frag.x / stripePx) - 0.5;
    float colShape = 1.0 - smoothstep(0.45, 0.5, abs(cx));

    // --- screen-space rows (dots)
    float dotPx = max(dotHeight, 1.0);
    float cy = fract(frag.y / dotPx) - 0.5;
    float rowShape = 1.0 - smoothstep(0.3, 0.5, abs(cy));

    float shapeMask = colShape * rowShape;

    // --- scan jitter
    float scan = 0.9 + 0.1 * sin(frag.y * 0.25 + time * 8.0);
    shapeMask *= scan;

    float mask = shapeMask;

    // ----------------------------
    // 1) CLEAN BASE IMAGE (no mask)
    // ----------------------------
    vec3 baseImage = src; // full clarity

    // subtle brightness lift for display
    baseImage *= 0.12;

    // ----------------------------
    // 2) EMISSIVE CRT LAYER
    // ----------------------------
    float emissiveStrength = b * mask * flickerFinal;

    // CRT glow color + optional tint hint
    vec3 crtColor = mix(baseImage,glowColor, tintMix);

    // emissive overlay (THIS carries scanlines/dots)
    vec3 emissive = crtColor * emissiveStrength;

    // ----------------------------
    // 3) COMBINE (additive, not destructive)
    // ----------------------------
    vec3 color = baseImage + emissive;

    // ----------------------------
    // 4) Bloom ONLY on emissive
    // ----------------------------
    color += emissive  * uBloomIntensity;

    // gentle gamma
    color = pow(color, vec3(0.95));


    // final alpha combines brightness + mask
    float finalAlpha = alpha * mask;

    // optionally discard near-zero alpha for fully cutout behavior (uncomment if wanted)
    // if (finalAlpha < 0.01) discard;

    gl_FragColor = vec4(color, finalAlpha);
  }
`

};

export const HeightFogShader = {
  uniforms: {
    tDiffuse: { value: null },
    fogColor: { value: new THREE.Color(0x0a1532) },
    fogNear: { value: 30.0 },
    fogFar: { value: 300.0 },
    height: { value: 60.0 },      // center of fog height
    heightScale: { value: 0.02 }, // how fast fog increases near ground
  },
  vertexShader: `
    varying vec2 vUv;
    varying float vWorldY;
    void main() {
      vUv = uv;
      vec4 worldPos = modelMatrix * vec4(position, 1.0);
      vWorldY = worldPos.y; // store world height
      gl_Position = projectionMatrix * viewMatrix * worldPos;
    }
  `,
  fragmentShader: `
    uniform sampler2D tDiffuse;
    uniform vec3 fogColor;
    uniform float fogNear;
    uniform float fogFar;
    uniform float height;
    uniform float heightScale;
    varying vec2 vUv;
    varying float vWorldY;

    void main() {
      vec4 scene = texture2D(tDiffuse, vUv);

      // distance fog
      float depth = gl_FragCoord.z / gl_FragCoord.w;
      float distFog = smoothstep(fogNear, fogFar, depth);

      // height fog (ground fog)
      float heightFog = clamp(exp(-(vWorldY - height) * heightScale), 0.0, 1.0);

      // combine
      float fogAmount = distFog * heightFog;

      gl_FragColor = mix(scene, vec4(fogColor, 1.0), fogAmount);
    }
  `
};

export const BloomTintShader = {
  uniforms: {
    tDiffuse: { value: null },
    colorA: { value: new THREE.Color(0xff0000) }, // pink
    colorB: { value: new THREE.Color(0xffddc6ff) }, // blue
    mixValue: { value: 0.5 }
  },
  vertexShader: `
    varying vec2 vUv;
    void main(){
      vUv=uv;
      gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0);
    }
  `,
  fragmentShader: `
    uniform sampler2D tDiffuse;
    uniform vec3 colorA;
    uniform vec3 colorB;
    uniform float mixValue;
    varying vec2 vUv;
    void main(){
      vec4 tex=texture2D(tDiffuse,vUv);
      float brightness = length(tex.rgb);
      vec3 color = mix(colorA,colorB,vUv.y);
      tex.rgb += color * brightness * mixValue;
      gl_FragColor = tex;
    }
  `
};

const windowShader = {
      vertexShader: `
        varying vec2 vUv;
        varying vec3 vPosition;
        void main() {
          vUv = uv;
          // pass model-space position (or use modelMatrix for world-space)
          vPosition = (modelMatrix * vec4(position, 1.0)).xyz;
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }`
      ,
      fragmentShader: `
        uniform float time;
        varying vec2 vUv;
        varying vec3 vPosition;
        uniform vec2 resolution;

        //	Classic Perlin 2D Noise 
        //	by Stefan Gustavson (https://github.com/stegu/webgl-noise)
        //
        vec2 fade(vec2 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}
        vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}

        float cnoise(vec2 P){
          vec4 Pi = floor(P.xyxy) + vec4(0.0, 0.0, 1.0, 1.0);
          vec4 Pf = fract(P.xyxy) - vec4(0.0, 0.0, 1.0, 1.0);
          Pi = mod(Pi, 289.0); // To avoid truncation effects in permutation
          vec4 ix = Pi.xzxz;
          vec4 iy = Pi.yyww;
          vec4 fx = Pf.xzxz;
          vec4 fy = Pf.yyww;
          vec4 i = permute(permute(ix) + iy);
          vec4 gx = 2.0 * fract(i * 0.0243902439) - 1.0; // 1/41 = 0.024...
          vec4 gy = abs(gx) - 0.5;
          vec4 tx = floor(gx + 0.5);
          gx = gx - tx;
          vec2 g00 = vec2(gx.x,gy.x);
          vec2 g10 = vec2(gx.y,gy.y);
          vec2 g01 = vec2(gx.z,gy.z);
          vec2 g11 = vec2(gx.w,gy.w);
          vec4 norm = 1.79284291400159 - 0.85373472095314 * 
            vec4(dot(g00, g00), dot(g01, g01), dot(g10, g10), dot(g11, g11));
          g00 *= norm.x;
          g01 *= norm.y;
          g10 *= norm.z;
          g11 *= norm.w;
          float n00 = dot(g00, vec2(fx.x, fy.x));
          float n10 = dot(g10, vec2(fx.y, fy.y));
          float n01 = dot(g01, vec2(fx.z, fy.z));
          float n11 = dot(g11, vec2(fx.w, fy.w));
          vec2 fade_xy = fade(Pf.xy);
          vec2 n_x = mix(vec2(n00, n01), vec2(n10, n11), fade_xy.x);
          float n_xy = mix(n_x.x, n_x.y, fade_xy.y);
          return 2.3 * n_xy;
        }

        // Hash function to generate random values
        float random(float x) {
          return fract(sin(x * 12.9898) * 43758.5453);
        }
        
        // void main() {
        //   vec3 color = vec3(0.0);

        //   // number of moving lines
        //   const int NUM_LINES = 8;

        //   // thickness in pixels
        //   float thicknessPx = 3.0;

        //   // normalized time base
        //   float t = time;

        //   // For each line compute an independent offset and speed using a hash
        //   for (int i = 0; i < NUM_LINES; i++) {
        //     float fi = float(i);

        //     // random seed per-line
        //     float seed = random(fi * 13.37);

        //     // random speed per-line (range)
        //     float speed = mix(0.02, 0.2, random(fi * 7.13 + 0.5));

        //     // random start offset so they spawn at different times (0..1)
        //     float offset = seed;

        //     // line position in normalized screen space [0..1], moving upward
        //     float linePos = fract(t * speed + offset);

        //     // convert to pixel Y and compute distance in pixels from this fragment
        //     float pixelY = gl_FragCoord.y;
        //     float targetY = linePos * resolution.y;
        //     float distPx = abs(pixelY - targetY);

        //     // sharp line, can use smoothstep for soft edges
        //     float line = smoothstep(thicknessPx + 1.0, thicknessPx - 1.0, distPx);

        //     // color/intensity variation
        //     float intensity = mix(0.6, 1.2, random(fi * 3.21 + floor(t * 2.0)));

        //     // accumulate bluish line
        //     color += vec3(0.0, 0.6, 1.0) * line * intensity;
        //   }

        //   // clamp/tonemap
        //   color = clamp(color, 0.0, 1.5);

        //   gl_FragColor = vec4(color, 1.0);
        // }

        void main() {
          float glow =  0.5 + 0.5;
          vec3 color = vec3(0.4, 0.6, 0.8); // Warm window color
          // float noiseValue = cnoise(vUv * 10.0 + vec2(time * 0.5, time * 0.5));

          // Use vPosition as unique seed per window
          float uniqueSeed = vPosition.x * 123.456 + vPosition.y * 789.012 + vPosition.z * 345.678;
          
          // Noise frequency control — increase to zoom IN (more detail)
          float noiseScale = 6000000.0; // try values like 20.0, 60.0, 120.0
          vec2 noiseUv = vUv * noiseScale;

          // Random time offset per window
          float timeOffset = random(uniqueSeed) * 1.0;

          // Create grid-like pattern by rounding UV coordinates
          vec2 grid = floor(vUv * 350.0) / 0.35; // Adjust 20.0 to change grid density
          // vec2 grid = floor(vUv * 25.0) / 0.3; // Adjust 20.0 to change grid density
          float noiseValue = cnoise(grid + vec2((time)* 0.1));
          
          // Create window on/off effect
          float windowThreshold = 0.2;
          float windowState = step(windowThreshold, noiseValue);
          
          // Add some flickering to active windows
          // float flicker = sin(time * 20.0) * 0.1 + 0.9;
          float flicker = 0.1 + 0.9;
          
          // Combine effects
          vec3 finalColor = color * glow * windowState * flicker;
              
          gl_FragColor = vec4(finalColor, 1.0);
        }

      `
    };

//=============================================================================
/*
    // void main() {
    //   float glow =  0.5 + 0.5;
    //   vec3 color = vec3(1.0, 0.9, 0.5); // Warm window color
    //   // float noiseValue = cnoise(vUv * 10.0 + vec2(time * 0.5, time * 0.5));

    //   // Use vPosition as unique seed per window
    //   float uniqueSeed = vPosition.x * 123.456 + vPosition.y * 789.012 + vPosition.z * 345.678;
        
    //   // Noise frequency control — increase to zoom IN (more detail)
    //   float noiseScale = 6000000.0; // try values like 20.0, 60.0, 120.0
    //   vec2 noiseUv = vUv * noiseScale;

    //   // Random time offset per window
    //   float timeOffset = random(uniqueSeed) * 1.0;

    //   // Create grid-like pattern by rounding UV coordinates
    //   vec2 grid = floor(vUv * 350.0) / 0.35; // Adjust 20.0 to change grid density
    //   // vec2 grid = floor(vUv * 25.0) / 0.3; // Adjust 20.0 to change grid density
    //   float noiseValue = cnoise(grid + vec2((time - timeOffset)* 0.1));
        
    //   // Create window on/off effect
    //   float windowThreshold = 0.2;
    //   float windowState = step(windowThreshold, noiseValue);
        
    //   // Add some flickering to active windows
    //   // float flicker = sin(time * 20.0) * 0.1 + 0.9;
    //   float flicker = 0.1 + 0.9;
        
    //   // Combine effects
    //   vec3 finalColor = color * glow * windowState * flicker;
            
    //   gl_FragColor = vec4(finalColor, 1.0);
    // }

*/
